// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Committee } from './committee';
import { Person } from './person';

/// <code-import> Place custom imports between <code-import> tags
import moment from 'moment';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CommitteeMember extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get term() {
        return `${moment(this.startDate).year()}-${!!this.endDate ? moment(this.endDate).year() : ' Est. ' + moment(this.startDate).add(3, 'years').year()}`;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  chair!: boolean;
  clerk!: boolean;
  committeeId!: number;
  endDate?: Date;
  personId!: number;
  startDate?: Date;
  committee!: Committee;
  person!: Person;
}

